import { createFileRoute } from "@tanstack/react-router";
import { ShapePicker } from "@/features/shapes";

/**
 * THE SHAPE PICKER — pushed from the deck's `Any shape` pill (frame `10b`).
 *
 * ⚠️ A PUSHED SCREEN AND NOT A SHEET, which is the design system's own rule read the way it is
 * written: a sheet resolves a SINGLE decision, and this is browsing — six tabs over thirty
 * rows, an expandable breakdown, and a choice made after reading. The gym picker on the same
 * header IS a sheet, and correctly: it is one list of rooms and one tap.
 *
 * SINGULAR `/shape` AND NOT `/shapes`, because the URL names what the athlete is choosing —
 * the shape their next session runs — and not the library it is chosen from. The LIBRARY is
 * `/v1/shapes` and the feature is `features/shapes`; a route is a screen, not a domain.
 *
 * The screen owns its own header bar, the way every pushed screen in this app does.
 */
export const Route = createFileRoute("/_app/shape")({
  component: ShapeScreen,
});

function ShapeScreen() {
  return <ShapePicker />;
}
